import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { DashboardPage } from "@/pages/DashboardPage";
import { ManagerPage } from "@/pages/ManagerPage";
import { ScreenerPage } from "@/pages/ScreenerPage";
import { CompanyPage } from "@/pages/CompanyPage";
import { PortfolioPage } from "@/pages/PortfolioPage";
import { PolicyPage } from "@/pages/PolicyPage";
import { GovernancePage } from "@/pages/GovernancePage";
import { AuditPage } from "@/pages/AuditPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { WatchlistPage } from "@/pages/WatchlistPage";
import { BriefingPage } from "@/pages/BriefingPage";
import { StrategiesPage } from "@/pages/StrategiesPage";
import { ThemeProvider } from "@/lib/theme";

export function App() {
  return (
    <ThemeProvider>
    <BrowserRouter>
      <Shell>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/manager" element={<ManagerPage />} />
          <Route path="/briefing" element={<BriefingPage />} />
          <Route path="/strategies" element={<StrategiesPage />} />
          <Route path="/screener" element={<ScreenerPage />} />
          <Route path="/company/:id" element={<CompanyPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/policy" element={<PolicyPage />} />
          <Route path="/governance" element={<GovernancePage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/watchlist" element={<WatchlistPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Shell>
    </BrowserRouter>
    </ThemeProvider>
  );
}
